function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.2,
  x: 33.7285,
  y: 16.9595,
  width: 291.542,
  height: 219.666,
  rx: 18,
  fill: "#0D5ED7"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.15,
  x: 53.1113,
  width: 252.777,
  height: 219.666,
  rx: 18,
  fill: "#0D5ED7"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#visashadow0_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 36.3413,
  width: 319,
  height: 219.666,
  rx: 18,
  fill: "url(#visashadow0_linear)"
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "visashadow0_d",
  x: 0,
  y: 16.3413,
  width: 359,
  height: 259.666,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  radius: 2,
  operator: "dilate",
  in: "SourceAlpha",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "visashadow0_linear",
  x1: 186.768,
  y1: 229.356,
  x2: 306.696,
  y2: 10.4983,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2C77BC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9DCDFD"
})));

var SvgVisaCardShadow = function SvgVisaCardShadow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 359,
    height: 277,
    viewBox: "0 0 359 277",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisaCardShadow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visa-card-shadow.79ce332a.svg";
export { ForwardRef as ReactComponent };